var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abstract",class:[_vm.truncateAbstract && 'truncate-abstract', _vm.textPadding && 'pa-2'],domProps:{"innerHTML":_vm._s(_vm.sanitizedAbstract)}})
}
var staticRenderFns = []

export { render, staticRenderFns }